export default {
      id: "error-usage",
      viewBox: "0 0 428 167",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#error-usage",
      toString: function () {
        return this.url;
      }
    }